/*
 * @Author: monai
 * @Date: 2021-03-22 14:47:09
 * @LastEditors: monai
 * @LastEditTime: 2025-06-03 15:17:40
 */

import { h5ObtainSupportedMethods, h5ObtainStreamerUid } from './hybrid';
import { getQueryString, fnColorLog } from '@activity-business/h5-package-frameworkTool';
import getProfile from '@library/JSBridgeFunction/profile';
import HttpClient from '@library/httpClient_activity.js';
import { ResourceType } from '@library/enum/index';

type GetLanguage = (includesLangList: string[]) => Promise<string>;
type TimeSplit = (time: number, endText?: string, initText?: string, initTime?: number) => string[];
// 根据礼物ID、类型 获取礼物 MD5
type GetResourceSrc = (list: { resourceId: number, type: ResourceType }[]) => Promise<{ resourceId: number, type: ResourceType, image: string | null }[]>
type GetShareEncrypt = (activityId: number | string, type?: number) => Promise<string>;


export const getLanguage: GetLanguage = async includesLangList => {
    //  获取 h5ObtainProfile_info，error 为 {}
    let profile = await getProfile();
    let LANG: string,
        //  Android IOS 返回不同，兼容。
        deviceLang: string | undefined, deviceLanguage: string | undefined;
    //  已获取到 h5Profile.device
    if (profile) ({ lang: deviceLang, language: deviceLanguage } = profile.device);
    //	优先级: url lang > app获取lang > 都未获取默认 includesLangList[0]
    LANG = getQueryString('lang') || deviceLang || deviceLanguage || includesLangList[0];
    //  印度
    if (LANG == 'hi') LANG = 'IN';
    //  印尼
    if (LANG == 'in' || LANG == 'id') LANG = 'ID';
    //  韩国
    if (LANG == 'ko') LANG = 'KR';
    //  越南
    if (LANG == 'vi' || LANG == 'vn') LANG = 'VN';
    //  阿拉伯
    if (LANG == 'ar') LANG = 'EG';
    //  美国
    if (LANG == 'en') LANG = 'US';
    //  马来
    if (LANG == 'ms') LANG = 'MY';
    //  日本
    if (LANG == 'ja') LANG = 'JP';
    //  简体
    if (LANG == 'zh' || LANG == 'zh_CN') LANG = 'ZH'
    //  繁体
    if (LANG == 'zh-TW' || LANG == 'zh_TW') LANG = 'TW';
    //  同义转换为大写
    LANG = LANG.toUpperCase();
    //  文案中不存在 LANG 文案，默认显示 includesLangList[0]
    LANG = includesLangList.includes(LANG) ? LANG : includesLangList[0];

    return LANG;
}

/**
 * time: 倒计时，单位 ms
 * endText: 结束时文案，默认 --
 * initText: 初始化时文案，默认 --
 * initTime: 函数内初始化时判断值，默认 -99
 */
export const timeSplit: TimeSplit = (time, endText = '--', initText = '--', initTime = -99) => {
    //  -99 展示默认初始文案，在时间未加载出来前，保持页面统一，默认 -99
    if (time == initTime) return [initText];
    //  结束文案
    if (time <= 0) return [endText];

    let day = Math.floor(time / 1000 / 60 / 60 / 24);
    let hour = Math.floor(time / 1000 / 60 / 60 % 24);
    let minute = Math.floor(time / 1000 / 60 % 60);
    let seconds = Math.floor(time / 1000 % 60);

    return [
        day.toString(),
        hour > 9 ? hour.toString() : '0' + hour,
        minute > 9 ? minute.toString() : '0' + minute,
        seconds > 9 ? seconds.toString() : '0' + seconds
    ]
}

// 获取动态礼物
export const getResourceSrc: GetResourceSrc = async function (list) {
    return await HttpClient.get(`/activity/center/web/h5/config/imageResource/getImage`, {
        params: {
            value: JSON.stringify(list)
        }
    }).then(res => {
        let { data: { data, errorCode } } = res;
        if (errorCode !== 0) throw res;
        return data;
    }).catch(err => {
        console.log(err);
        return [];
    });
}

export const fnGetTargetUid = async () => {
    // // URL 参数优先级最大
    // const URLparams = getQueryString('targetUid');
    // if (URLparams) return URLparams;
    // // 查询获取 UID 方法是否支持
    // const supported = await h5ObtainSupportedMethods()
    //     .then(res => {
    //         const { methods = [] } = res;
    //         return methods.includes('h5_obtainStreamerUid');
    //     })
    //     .catch(console.log);

    // // 获取 UID
    // const uid = !supported ? undefined : await h5ObtainStreamerUid()
    //     .then(data => {
    //         const { uid } = data;
    //         return uid;
    //     })
    //     .catch(console.log);



    /***** 暂时关闭 h5_obtainStreamerUid 方法支持判断*****/
    //! IOS 端能支持 h5_obtainStreamerUid API，但是 h5ObtainSupportedMethods 并没有返回此 API 名称
    // URL 参数优先级最大
    const URLparams = getQueryString('targetUid');
    if (URLparams) return URLparams;
    // 获取 UID
    const uid = await h5ObtainStreamerUid()
        .then(data => {
            const { uid } = data;
            return uid;
        })
        .catch(console.log);

    return uid;
};


/**
 * 游戏活动开关控制
 * 获取到指定参数 ? 链接安全 : 链接危险(危险跳转欢迎页)
 * @param key 关键字段
 */
export const fnGetGameControl = (key: string = 'activityGameType'): void => {
    const EXISTBOOL = getQueryString(key) ? true : false;
    !EXISTBOOL && ENV !== 'develop' && window.location.replace(`${window.location.origin}/act_regular_welcome/index.html`);
}

/**
 * 通过lang值直接判断部门类型
 * @param lang 国家码，默认读取链接lang
 * @returns 1 一部 2 二部
 */
export const fnDepartmentType = (lang: string = getQueryString('lang')): number => {
    const secondPart = ['EG', 'TR', 'FR', 'DE'].includes(lang);
    return secondPart ? 2 : 1;
}

/**
 * MICO 站外分享获取加密串方法
 * @param activityId 
 * @param type 1 站外
 * @returns 加密串
 */
export const fnGetShareEncrypt: GetShareEncrypt = async (activityId: number | string, type: number = 1) => {
    // 校验活动ID是否传入
    if (!activityId) {
        fnColorLog('> 获取用户加密串接口 getShareEncrypt 未传入活动ID参数', 'error');
        throw new Error('请传入活动ID！');
    }
    
    let uid;
    // uid 获取，优先使用链接参数中的 uid，若没有则使用 profile 中的 uid
    // !测试环境 无法获取 jsbridge user 信息, 使用链接上的 targetUid
    const queryUid = getQueryString('targetUid');
    const apiUid = await getProfile();
    if(queryUid) uid = queryUid;
    else if(apiUid) uid = apiUid.user.uid;
    else {
        fnColorLog(`[${new Date().toLocaleString()}] fnGetShareEncrypt 无法获取用户 UID，请检查链接中的 targetUid 参数或用户信息！`, 'error');
        throw new Error('无法获取用户 UID');
    }

    try {
        // 发起加密请求
        const response = await HttpClient(<any>{
            url: '/activity/center/web/h5/activity/share/encrypt',
            params: { activityId, type, uid },
            ajaxCustomHeaders: {
                headers: {
                    uid,
                },
                cb: config => {
                    // 清理不必要的请求头
                    ['did', 'key', 'version'].forEach(key => delete config.headers[key]);
                }
            }
        });

        // 解析响应结果
        const {data: {data: {status, shareInfo}, errorCode}} = response;

        // 错误处理：如果 errorCode 非 0，抛出异常
        if (errorCode !== 0) {
            fnColorLog(`[${new Date().toLocaleString()}] fnGetShareEncrypt 获取加密串失败，errorCode: ${errorCode}`, 'error');
            throw new Error(`[${new Date().toLocaleString()}] fnGetShareEncrypt 获取加密串失败，错误码：${errorCode}`);
        }

        // 成功获取加密串，返回 shareInfo
        fnColorLog(`[${new Date().toLocaleString()}] fnGetShareEncrypt 获取加密串成功`, 'success', shareInfo);
        return shareInfo;

    } catch (err) {
        // 错误处理
        console.error('获取加密串失败:', err);
        throw err;  // 重新抛出异常，供外部调用处理
    }
}

// 判断当前国家国旗是否存在政治风险
export const fnGetFlagSafety = (flagInfo: {country: string;}) => {
    // 定义危险国家列表
    const warningCountries: Set<string> = new Set(['IR', 'SD', 'SY']);
    // 解构出关键字段
    const {country} = flagInfo;
    // 判断国家是否在危险国家列表中
    const isWarning = warningCountries.has(country);
    return isWarning;
}